import { AccountCircle } from '@mui/icons-material';
import { Grid, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';
import {
  createEventApplication,
  registerVendorEventSuccess,
} from '../../../../../core/vendor-events/action';
import { createUpdateVendorEvent } from '../../methods';
import { payerValidationSchema } from '../VendorInformation/validations';
import WizardButtons from '../WizardButtons';
import BookingFeeTerms from './BookingFeeTerms';

// eslint-disable-next-line react/prop-types
export default function Payment({ previousStep }) {
  const dispatch = useDispatch();
  const { currentVendorEvent, vendorEventPayload, totalAmountDue, currentStripeSession } =
    useSelector((store) => store.vendorEvents);
  const [bookingFeeTerms, setBookingFeeTerms] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (bookingFeeTerms) setAlertMessage('');
  }, [bookingFeeTerms]);

  const onChangeBookingFeeCheck = (e) => {
    setBookingFeeTerms(e.target.checked);
  };

  const applyToEvent = () => {
    dispatch(
      createEventApplication({
        eventId: vendorEventPayload.fk_event,
        vendorId: vendorEventPayload.fk_vendor,
        totalPrice: totalAmountDue,
      }),
    );
  };

  const onUpdateVendorEvent = () => {
    setLoading(true);
    const type = currentVendorEvent?.state ? 'update' : 'create';
    createUpdateVendorEvent(
      {
        ...vendorEventPayload,
        booking_fee_charge_terms: bookingFeeTerms,
      },
      type,
    )
      .then((data) => {
        dispatch(registerVendorEventSuccess(data));
        if (data.booking_fee_charge_terms) {
          applyToEvent();
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
    },
    validationSchema: payerValidationSchema,
    onSubmit: () => {
      if (!bookingFeeTerms) {
        setAlertMessage('Accept terms is required');
        return;
      }
      onUpdateVendorEvent();
    },
  });

  useEffect(() => {
    if (currentStripeSession?.id) {
      window.location.replace(currentStripeSession.url);
    }
  }, [currentStripeSession]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        <Grid container justifyContent="center">
          <Grid item>
            <Typography fontWeight="bold">Payer information:</Typography>
          </Grid>
          <Grid item>
            <Typography marginLeft={2}>Who will be the payer of this event?</Typography>
          </Grid>
        </Grid>
        <SimpleCard variant="outlined" sx={{ display: 'flex' }}>
          <Grid container columns={10} justifyContent={{ xs: 'center', md: 'left' }}>
            <Grid item xs={2} textAlign="center">
              <AccountCircle style={{ fontSize: '5rem' }} />
            </Grid>
            <Grid item>
              <TextField
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Name"
                name="name"
                value={formik.values.name || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
              />
              <TextField
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Phone Number"
                inputProps={{ maxLength: 10 }}
                name="phone"
                value={formik.values.phone || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
              />
              <TextField
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formik.values.email || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
          </Grid>
        </SimpleCard>
        <SimpleCard variant="outlined">
          <Grid container justifyContent="center">
            <Grid item xs={12} md={7}>
              <BookingFeeTerms
                bookingFeeTerms={bookingFeeTerms}
                onChangeBookingFeeCheck={onChangeBookingFeeCheck}
              />
            </Grid>
            {alertMessage && (
              <Grid container justifyContent="center">
                <Typography color="#EE7B57">{alertMessage}</Typography>
              </Grid>
            )}
          </Grid>
        </SimpleCard>
        <WizardButtons
          nextLabel="Apply"
          nextLabelButtonType="submit"
          loading={loading}
          previousStep={previousStep}
        />
      </div>
    </form>
  );
}
